import { forwardRef, useId, type TextareaHTMLAttributes } from 'react';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  hint?: string;
  invalid?: boolean;
}

/** Bootstrap 5 textarea with label and validation feedback. */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, hint, invalid = false, id, rows = 3, className = '', ...rest },
  ref,
) {
  const autoId = useId();
  const fieldId = id ?? autoId;
  const classes = ['form-control', invalid ? 'is-invalid' : '', className].filter(Boolean).join(' ');
  return (
    <div className="mb-3">
      {label && (
        <label className="form-label" htmlFor={fieldId}>
          {label}
        </label>
      )}
      <textarea id={fieldId} ref={ref} rows={rows} className={classes} {...rest} />
      {hint && <div className={invalid ? 'invalid-feedback d-block' : 'form-text'}>{hint}</div>}
    </div>
  );
});
